import React from 'react';
import trustPilot from "../../../assets/logo/trustpilot.png";
import Spinner from './Spinner';

const CompanyBlog = ({ video = [], text = [], isLoading = false }) => {
  return (
    <div>
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          {/* Top Two Videos */}
          <section className="bd-service-area">
            <div className="container" style={{ maxWidth: "1270px" }}>
              <div className="row">
                {Array.isArray(video) &&
                  video.slice(0, 2).map((content, idx) => (
                    <div className="col-lg-4 col-md-6 first-resp-section mt-80" key={idx}>
                      <div className="bd-service" style={{ backgroundColor: "var(--clr-bg-gray)", padding: "13px 17px 14px 18px" }}>
                        <div className="testimonial_video">
                          <iframe
                            src={content.video_link}
                            className="resp-videos"
                            allowFullScreen
                            frameBorder="0"
                            width="576"
                            height="300"
                            title={`testimonial-video-${idx}`}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </section>

      

          {/* Remaining Videos */}
          <section className="bd-service-area">
            <div className="container" style={{ maxWidth: "1270px" }}>
              <div className="row">
                {Array.isArray(video) &&
                  video.slice(2).map((content, idx) => (
                    <div className="col-lg-4 col-md-6 first-resp-section mt-80" key={`video-btm-${idx}`}>
                      <div className="bd-service" style={{ backgroundColor: "var(--clr-bg-gray)", padding: "13px 17px 14px 18px" }}>
                        <div className="testimonial_video">
                          <iframe
                            src={content.video_link}
                            className="resp-videos"
                            allowFullScreen
                            frameBorder="0"
                            width="576"
                            height="300"
                            title={`testimonial-video-bottom-${idx}`}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </section>

          {/* Remaining Text Testimonials */}
          {Array.isArray(text) &&
            text.slice(0 , 3  ).map((content, idx) => (
              <section className="bd-service-area" key={`text-btm-${idx}`}>
                <div className="container" style={{ maxWidth: "1270px" }}>
                  <div className="row">
                    <div className="col-lg-4 col-md-6 mt-80" style={{ width: "100%" }}>
                      <div className="bd-service mb-30 responsive-main_testimonial" style={{ backgroundColor: "var(--clr-bg-gray)", height: "100%" }}>
                        <div className="comments-box box-responsive">
                          <div className="comments-avatar mr-40 test-first-section1" style={{ width: "40%" }}>
                            <img src={content.company_logo} className="img-fluid mb-20" style={{ width: "100px" }} alt="Company Logo" />
                            <p style={{ marginBottom: "0px", color: "black", fontWeight: "570" }}>{content.name}</p>
                            <p style={{ textAlign: "center", width: "100%", marginBottom: "0px" }}>{content.designation}</p>
                            <p className="mb-0">{content.company_name}</p>
                            {content.testimony_link && (
                              <p style={{ marginBottom: "38px" }}>
                                View Review On <br />
                                <a href={content.testimony_link} target="_blank" rel="noopener noreferrer">
                                  <img src={trustPilot} width="35" alt="TrustPilot" />
                                  <br />TrustPilot
                                </a>
                              </p>
                            )}
                          </div>
                          <div className="comments-text pb-0 mb-0" style={{ border: "none", width: "100%" }}>
                            <div className="avatar-name">
                              <h4>{content.service}</h4>
                            </div>
                            <p style={{ lineHeight: "1.55", marginBottom: "10px" }}>{content.description}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            ))}
        </>
      )}
    </div>
  );
};

export default CompanyBlog;
